import React from "react";
import Card from "@mui/material/Card";
import { styled } from "@mui/material/styles";

// Fix: use shouldForwardProp to exclude `bgColor` from DOM
const CardIconContainer = styled(Card, {
  shouldForwardProp: (prop) => prop !== "bgColor",
})(({ bgColor }) => ({
  float: "left",
  margin: "-20px 20px 0 15px",
  zIndex: 100,
  borderRadius: 3,
  backgroundColor: bgColor,
}));

const CardIconInner = styled("div")(() => ({
  float: "right",
  width: 54,
  height: 54,
  padding: 14,
  color: "#fff",
}));

const CardIcon = ({ Icon, bgColor }) => {
  return (
    <CardIconContainer bgColor={bgColor}>
      <CardIconInner>
        <Icon />
      </CardIconInner>
    </CardIconContainer>
  );
};

export default CardIcon;
